// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Status_wrapper__2FSRH"};